export const CREATE_PRODUCT_REQUEST_ACTION = '[ProductRequest Action] Create ProductRequest';
export const CONFIRMED_CREATE_PRODUCT_REQUEST_ACTION = '[ProductRequest Action] Confirmed Create ProductRequest';
export const CREATE_PRODUCT_REQUEST_ERROR_ACTION = '[ProductRequest Action] Create ProductRequest Error';
export const GET_PRODUCT_REQUESTS = '[ProductRequest Action] Get ProductRequests';
export const CONFIRMED_GET_PRODUCT_REQUESTS = '[ProductRequest Action] Confirmed Get ProductRequests';
export const LOADING_PRODUCT_REQUESTS = '[ProductRequest Action] Loading for ProductRequests';
export const EDIT_PRODUCT_REQUEST_ACTION = '[ProductRequest Action] Edit ProductRequest';
export const CONFIRMED_EDIT_PRODUCT_REQUEST_ACTION = '[ProductRequest Action] Confirmed Edit ProductRequest';
export const DELETE_PRODUCT_REQUEST_ACTION = '[ProductRequest Action] Delete ProductRequest';
export const CONFIRMED_DELETE_PRODUCT_REQUEST_ACTION = '[ProductRequest Action] Confirmed Delete ProductRequest';
export const PRODUCT_REQUEST_ERROR_ACTION = '[ProductRequest Action] Error';
export const CLEAR_PRODUCT_REQUEST_ERROR = '[ProductRequest Action] Clear Error';

